import React from 'react';
import { NavLink,Link} from 'react-router-dom';
import Menu from '@isomorphic/shared/UIView/Antd/Menu/Menu';

import {
  HOME_PAGE,
  LISTING_POSTS_PAGE,
  AGENT_PROFILE_PAGE,
  PRICING_PLAN_PAGE,
  ADD_HOTEL_PAGE,
  AGENT_PROFILE_CONTACT,
} from '../../../settings/constant';

const MainMenu = ({ isLogin,className }) => {
  return (
    <Menu className={className}>
      <Menu.Item key="0">
        <NavLink exact to={`${HOME_PAGE}`}>
          Accueil
        </NavLink>
      </Menu.Item>
   
      <Menu.Item key="2">
        <NavLink to={`${ADD_HOTEL_PAGE}`}>Déterminer la valeur d'un bien</NavLink>
      </Menu.Item>
      <Menu.Item key="3">
        <a href="http://ziaway.info" target="_blank">Blog</a>
      </Menu.Item>
      <Menu.Item key="4">
        <NavLink to={`${AGENT_PROFILE_CONTACT}`}>Nous contacter</NavLink>
      </Menu.Item>
      {isLogin && <Menu.Item key="5">
         <NavLink to={AGENT_PROFILE_PAGE}>Mes biens</NavLink>
    
      </Menu.Item>}
    
    </Menu>
  );
};
/** <NavLink to={`${PRICING_PLAN_PAGE}`}>Abonnements</NavLink> */
export default MainMenu;
